module.exports = __webpack_public_path__ + "static/media/mobileprofile.27db4bd1.png";